import { CourseCardsProps } from "design-system/sites/online/components/course-card-tease/course-card-tease";
import { CourseSession, HBSOCourseSearchHit, SearchHit } from "frontend/types";
import { stripHtml } from "../components/utils/strip-html";
import { isSearchHitType } from "./is-search-hit-type";

export function createSearchCourseTease(data?: SearchHit) {
  if (isSearchHitType<HBSOCourseSearchHit>("modernCourse", data)) {
    return createModernSearchCourseTeaseCard(data);
  }
}

export function createModernSearchCourseTeaseCard(
  data: HBSOCourseSearchHit,
): CourseCardsProps {
  const selectedSessions: Array<CourseSession> = [];

  data.display?.sessions?.forEach((session) => {
    const onDemand = session.onDemand;

    // Only Push sessions that have not started yet or are on demand or are more than 6 months in the future
    if (!onDemand) {
      const now = new Date().getTime();
      const startDate = session.startDate
        ? new Date(session.startDate).getTime()
        : 0;
      const sixMonthsFromNow = now + 180 * 24 * 60 * 60 * 1000;
      const alreadyStarted = startDate < now;
      if (alreadyStarted || startDate > sixMonthsFromNow) {
        return;
      }
    }
    selectedSessions.push(session);
  });

  const sessions = selectedSessions
    ?.map((session) => ({
      startDate: session.onDemand ? undefined : session.startDate,
      endDate: session.endDate,
      deadline: session.onDemand ? undefined : session.deadline,
      applicationDueDate: session.applicationDueDate,
      sortDate: session.startDate,
      time: session.time,
      fee: session.fee,
      type: session.type,
      onDemand: session.onDemand,
      sessionCalendar: session.sessionType,
      sessionType: session.sessionType ? session.sessionType : undefined,
    }))
    .sort((a, b) => {
      if (!a.startDate || !b.startDate) return 0;
      return new Date(a.startDate).getTime() - new Date(b.startDate).getTime();
    });

  const props: CourseCardsProps = {
    type: "Course",
    id: data.id,
    category: data.topic,
    title: data.title,
    overline: data.topic?.[0],
    description: data.description && stripHtml(data.description),
    link: data.url,
    isExEd: false,
    format: data.format,
    isMultiCourse: data.display?.isMultiCourse,
    multiCourseLength: data.display?.courseCount
      ? (parseInt(data.display?.courseCount, 10) as number)
      : undefined,
    multiCourseCardHighlights: data.display?.multiCourseCardHighlights,
    thumbnail: {
      image: data.display?.thumbnail,
    },

    sessions: sessions,
  };

  return props;
}
